import { Box } from '@mui/material';
import React from 'react';

const CircleBadge = React.forwardRef(({
	children,
	onClick,
	size = 36,
	className = '',
}, ref) => {
	return (
		<Box
			ref={ref}
			onClick={onClick}
			className={`flex items-center justify-center rounded-full bg-investor-bg cursor-pointer hover:opacity-90 transition-opacity ${className}`}
			sx={{ width: size, height: size }}>
			{children}
		</Box>
	);
});

CircleBadge.displayName = 'CircleBadge';

export default CircleBadge;
